import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"
import { IProduct, IPrice } from "../helpers"
import { Product } from "./Product"
import { Link } from "gatsby"
import { Card } from "."

interface Props {
  products: IProduct[]
  className?: string
}

export const ProductGrid: React.FC<Props> = ({ products, className }) => {
  return (
    <StyledGrid.Wrapper className={className}>
      {products.map(({ fields: { slug }, id, title, image, price, suffix }) => (
        <Link key={id + slug} to={`/products/${slug}`}>
          <StyledGrid.Card>
            <Product
              withTitle
              title={title}
              fluid={image.childImageSharp.fluid}
              price={price as IPrice}
              suffix={suffix}
            />
          </StyledGrid.Card>
        </Link>
      ))}
    </StyledGrid.Wrapper>
  )
}

const StyledGrid = {
  Wrapper: tw.div`grid w-full gap-8 md:grid-cols-2 lg:grid-cols-3`,
  Card: tw(
    Card
  )`flex justify-center h-full px-10 py-4 transition-transform duration-200 ease-in-out hover:transform hover:-translate-y-1`,
}
